<template>
    <div class="toast-messages">
        <Toast
            v-for="(msg, index) in messages"
            :key="index"
            radius="m"
            title="NOTE"
            color="yellow"
            fullWidth
            columnMobile>
            {{ msg }}
        </Toast>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { getMessagesByPage } from '../DevPanel.helpers';
    import { DevPanelPage } from '../DevPanel.interfaces';
    import Toast from '@ui/components/Toast/Toast.vue';

    export default defineComponent({
        name: 'MessagesPanel',
        components: { Toast },
        props: {
            page: { type: String as PropType<DevPanelPage>, required: true },
        },
        setup(props) {
            const messages = computed(() => getMessagesByPage(props.page));
            return { messages };
        },
    });
</script>
<style lang="scss" scoped>
    @use '@/styles/import.scss' as *;

    .toast-messages {
        @include flex(column);
        gap: var(--spacing-16);
        width: 100%;
    }
</style>
